import {
  WSActions,
  WSAlert,
  WSElement,
  WSFlexBox,
  WSList,
  WSLoader,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useEmployeeTaxFormsEngagementContext } from "../hooks/useEmployeeTaxFormsEngagementContext";
import { useEmployeeTaxFormsChecklistView } from "../hooks/useEmployeeTaxFormsChecklistView";
import { ChecklistEmptyState } from "../components/ChecklistEmptyState";
import { ChecklistRows } from "../components/ChecklistRows";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const EmployeeTaxFormsChecklist: React.FC<FlowStep> = ({ onNext }) => {
  const engagementId = useEmployeeTaxFormsEngagementContext();
  const { isLoading, orderedItems, allCompleted, completedCount } =
    useEmployeeTaxFormsChecklistView(engagementId);

  if (engagementId && isLoading) {
    return (
      <WSFlexBox.Center py="3XL">
        <WSLoader.Spinner size="M" />
      </WSFlexBox.Center>
    );
  }

  if (orderedItems.length === 0) {
    return (
      <WSList gap="2XL">
        <ChecklistEmptyState />
        {onNext ? (
          <WSActions
            alignment="fill"
            buttons={[{ label: "Continue", onClick: onNext, kind: "Primary" }]}
          />
        ) : null}
      </WSList>
    );
  }

  return (
    <WSList gap="2XL">
      <WSElement>
        <WSText.Heading4>Tax form requirement</WSText.Heading4>
        <WSText.ParagraphSm color="gray500" mt="XS">
          {allCompleted
            ? "All forms are complete. You can review any form below."
            : "Complete and sign each form below. We'll save your progress as you go."}
        </WSText.ParagraphSm>
        {!allCompleted && orderedItems.length > 0 ? (
          <WSText.ParagraphSm color="gray500" mt="XS">
            {completedCount} of {orderedItems.length} forms complete
          </WSText.ParagraphSm>
        ) : null}
      </WSElement>

      {allCompleted ? (
        <WSAlert theme="success">
          All tax forms are submitted. Payroll can run for this engagement.
        </WSAlert>
      ) : null}

      <ChecklistRows items={orderedItems} />

      {onNext ? (
        <WSActions
          alignment="fill"
          buttons={[
            {
              label: allCompleted ? "Continue" : "I'll finish this later",
              onClick: onNext,
              kind: allCompleted ? "Primary" : "Tertiary"
            }
          ]}
        />
      ) : null}
    </WSList>
  );
};
